import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateEventFormDTO, EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createExpoRegistrationForm } = EventsApiService();

export const useExpoCreateRegistrationForm = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CreateEventFormDTO) => {
            return createExpoRegistrationForm(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Expo Booth Registration Created Successfully");
            },
        },
    );
};
